import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from "@angular/core";
import { NotificationBase } from "../notifications/notification-base.component";

@Component({
  selector: "snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent extends NotificationBase {
  @Output() dismissed: EventEmitter<void> = new EventEmitter<void>();

  dismiss(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dismissed.emit();
  }
}
